module.exports = __webpack_public_path__ + "static/media/WorldMap.26442d7d.svg";